var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "component" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "main-content" },
      [_c("portrait-labels", { attrs: { labelList: _vm.componentData } })],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "main-title" }, [
      _c("div", { staticClass: "square" }),
      _vm._v(" "),
      _c("div", { staticClass: "title-content" }, [_vm._v("求职意向")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }